import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';

import RecoveryPassword from "../components/RecoveryPassword";

function FormLogin() {
    const navigate = useNavigate();
    const [remember, setRemember] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm({
        initialValues: {
            email: "",
            password: "",
            remember: false
        }
    })

    const validar = async (data) => {
        let remember = data.remember;

        let info = { ...data };
        delete info.remember;

        let uri = process.env.REACT_APP_API_URL + 'login';

        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        };

        try {
            let response = await axios({
                method: 'POST',
                url: uri,
                data: info,
                headers: config.headers
            });
            // console.log(response);
            Cookies.set("AuthToken", response.data.token, { 
                expires: 2
            });
            Swal.fire(
                {
                    title: 'Bienvenido',
                    text: 'Inicio de sesión exitoso',
                    icon: 'success',
                    confirmButtonText: 'Aceptar'
                }
            )
            .then(function () {
                if (remember) {
                    Cookies.set("logged_data", JSON.stringify({
                        email: info.email,
                        active: true
                    }), { expires: 1 });
                } else {
                    Cookies.remove("logged_data");
                }

                navigate("/Inicio");
            })
        } catch (error) {
            console.log(error);
            Swal.fire({
                title: "Encontramos inconvenientes al iniciar sesión",
                text: "Usuario o contraseña incorrectos, intenta nuevamente",
                icon: "warning",
            });
        }

    }

    const loadData = () => {
        let data = Cookies.get("logged_data");
        if (data) {
            let info = JSON.parse(data);
            
            if (info.active) {
                document.getElementById("userEmail").value = info.email;
                setRemember(true);
            }
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="h-full flex justify-center items-center px-10 md:px-20 py-10">
            <div className="rounded-xl bg-white border-2 w-full">
                <div className="w-full p-4">
                    <h2 className="md:text-3xl text-2xl font-bold text-[#0E7FA0] text-center py-3 px-10">
                        Puedes iniciar sesión como Beneficiario
                    </h2>
                    <div className="flex justify-center items-center">
                        <Link to="/Beneficiario" data-discover="true" className="bg-[#AADEE9] block text-center font-medium p-2 text-white w-full md:w-2/3 rounded-full transition-colors hover:bg-[#66b9cc]">
                            Beneficiario
                        </Link>
                    </div>
                    <hr className="border-[#AADEE9] mt-4 w-full" />
                    <div className="w-full shadow-3xl rounded-2xl border-[#0E7FA0]">
                        <form className="md:px-16 py-4" onSubmit={handleSubmit(validar)}>
                            <div className="text-md mb-2">
                                <label htmlFor="userEmail" className="normal-case font-medium text-sky-900 text-base font-sans">Usuario</label>
                                <input 
                                    // ref={ emailRef } 
                                    id="userEmail" 
                                    placeholder="Usuario" 
                                    className="bg-white rounded-2xl border border-[#0D3B66] pl-4 py-2 md:py-2 focus:outline-none w-full" 
                                    type="email" 
                                    {...register("email", {
                                        required: {
                                            value: true,
                                            message: "Usuario no válido"
                                        },
                                        pattern: {
                                            value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                            message: "Correo no válido"
                                        }
                                    })} 
                                />
                                {errors.email && <span className="text-sm text-red-600 font-bold">{errors.email.message}</span>}
                            </div>
                            <div className="text-md mb-6 md:mb-3">
                                <label htmlFor="userPassword" className="normal-case font-medium text-sky-900 text-base font-sans">Contraseña</label>
                                <input id="userPassword" placeholder="Contraseña" className="bg-white rounded-2xl border border-[#0D3B66] pl-4 py-1 md:py-2 focus:outline-none w-full" type="password" {...register("password", {
                                    required: {
                                        value: true,
                                        message: "La contraseña es requerida"
                                    }
                                })} />
                                {errors.password && <span className="text-sm text-red-600 font-bold">{errors.password.message}</span>}
                            </div>
                            <div className="text-md items-center">
                                <button type="submit" className="bg-[#0E7FA0] font-medium ring-offset-slate-200 shadow-2xl p-2 text-white w-full rounded-full hover:bg-[#0D3B66] transition-colors">
                                    Acceder
                                </button>
                                <div className="pt-6 w-auto text-sm text-center md:flex justify-between">
                                    <div>
                                        <input 
                                            type="checkbox" 
                                            id="remember" 
                                            className="mr-1"
                                            checked={remember}
                                            {...register("remember")}
                                            onChange={(e) => {
                                                setRemember(e.target.checked);
                                            }}
                                        />Recuerdame
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            className="text-custom-main hover:text-cyan-800" 
                                            onClick={RecoveryPassword}
                                        >
                                            <p className="px-1">¿Olvidaste tu contraseña?</p>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FormLogin;   